import axios, { AxiosError, AxiosInstance } from 'axios';

import { KEY_API_TOKEN, KEY_EMAIL, KEY_PLUGIN_AUTHORIZATION } from 'const';
import { ResponseSignIn } from './types/client';

const { REACT_APP_API_BASE_URL: URL_BASE_COVE } = process.env;

const DEFAULTS_CLIENT_COVE = {
  baseURL: URL_BASE_COVE,
  headers: { 'Content-Type': 'application/json' },
};
const coveClient = axios.create(DEFAULTS_CLIENT_COVE);

coveClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(KEY_API_TOKEN);
    if (!token) return config;
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Token ${token}`,
      },
    };
  },
  (err) => Promise.reject(err),
);

coveClient.interceptors.response.use(
  (res) => res,
  async (err: AxiosError) => {
    const { response } = err;

    if (response?.status !== 401) {
      return Promise.reject(err);
    }
    if (!localStorage.getItem(KEY_EMAIL)) {
      throw new Error('Failed Sign In');
    }
    if (!localStorage.getItem(KEY_PLUGIN_AUTHORIZATION)) {
      throw new Error('Failed Sign In');
    }
    try {
      const client = axios.create(DEFAULTS_CLIENT_COVE);
      const payload = {
        username: localStorage.getItem(KEY_EMAIL),
        password: localStorage.getItem(KEY_PLUGIN_AUTHORIZATION),
      };
      const rs: ResponseSignIn = await client.post('/auth/signin', payload);
      if (rs.status === 400) {
        throw new Error('Failed Sign In');
      }
      const { data: { token } } = rs;
      localStorage.setItem(KEY_API_TOKEN, token);
      return undefined;
    } catch (e: AxiosError | Error | any) {
      if (axios.isAxiosError(e)) {
        throw new Error('Failed Sign In');
      }
      return Promise.reject(e);
    }
  },
);

const getClient = (provider: 'cove' | 'procore'): AxiosInstance => {
  switch (provider) {
    case 'cove':
      return coveClient;
    default:
      throw Error(`Unexpected value: ${provider}`);
  }
};

export default getClient;
